import { Controller } from "remult";

@Controller("volunteer-organization-contact-methods")
export class VolunteerOrganizationContactMethods {}
